export const SET_REFUNDED_ORDER_ITEMS__ORDER_CANCELLATION =
  'orderCancellation/SET_CANCELLATION_ORDER_ITEMS__ORDER_CANCELLATION';
export const FETCH_CANCELLATION_REASONS_PENDING__ORDER_CANCELLATION =
  'orderCancellation/FETCH_CANCELLATION_REASONS_PENDING__ORDER_CANCELLATION';
export const FETCH_CANCELLATION_REASONS_FULFILLED__ORDER_CANCELLATION =
  'orderCancellation/FETCH_CANCELLATION_REASONS_FULFILLED__ORDER_CANCELLATION';
export const FETCH_ORDER_REFUND_PENDING__ORDER_CANCELLATION =
  'orderCancellation/FETCH_ORDER_REFUND_PENDING__ORDER_CANCELLATION';
export const FETCH_ORDER_REFUND_REJECTED__ORDER_CANCELLATION =
  'orderCancellation/FETCH_ORDER_REFUND_REJECTED__ORDER_CANCELLATION';
export const FETCH_ORDER_REFUND_FULFILLED__ORDER_CANCELLATION =
  'orderCancellation/FETCH_ORDER_REFUND_FULFILLED__ORDER_CANCELLATION';



// WEBPACK FOOTER //
// ./src/constants/orderCancellation.js